import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { Screens } from '~/constants/config/permissions';
import { requireFeatureGate, requirePermission } from '~/utils/guards';

/**
 * Data Sharing (`/subsidiary/data-sharing`) — a Subsidiary Settings child, so
 * the section header and card nav stay visible. Gated by screen access and the
 * `ads-share-link` flag (registered as `integrations_sharing`).
 */
const SharingPage = lazy(() => import('~/features/connector-share/pages/sharing-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/data-sharing')({
  beforeLoad: async () => {
    requirePermission(Screens.INTEGRATIONS_SHARING)();
    await requireFeatureGate('integrations_sharing')();
  },
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SharingPage />
    </Suspense>
  ),
});
